import { render, staticRenderFns } from "./Guardians.vue?vue&type=template&id=ccc08216"
import script from "./Guardians.vue?vue&type=script&lang=js"
export * from "./Guardians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports